import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import { InlineError } from './Error';

import breakpoints from '../styles/breakpoints';

import Navigation from './Navigation';

const GET_MENUS = gql`
  query getMenus($menuLocationLeft: String!, $menuLocationRight: String!) {
    menuLeft: getWPMenuFromMenuLocation(menuLocation: $menuLocationLeft) {
      id
      title
      url
    }
    menuRight: getWPMenuFromMenuLocation(menuLocation: $menuLocationRight) {
      id
      title
      url
    }
  }
`;

const StyledHeader = styled.header`
  background: ${p => p.theme.colors.primary};
  padding: 32px 0;
  margin-bottom: 20px;

  ${breakpoints.medium`
        padding: 36px 0;
  `};

  ${breakpoints.large`
    padding: 55px 0;
  `};
`;

export default function Header() {
  return (
    <StyledHeader>
      <Query
        query={GET_MENUS}
        variables={{
          menuLocationLeft: 'primary-left',
          menuLocationRight: 'primary-right'
        }}
      >
        {({ loading, error, data }) => {
          if (loading) {
            return null;
          }

          if (error) {
            return <InlineError error={error} />;
          }

          if (!data) {
            return null;
          }

          const menuLeft =
            data.menuLeft && data.menuLeft.length ? data.menuLeft : null;
          const menuRight =
            data.menuRight && data.menuRight.length ? data.menuRight : null;

          return <Navigation left={menuLeft} right={menuRight} />;
        }}
      </Query>
    </StyledHeader>
  );
}
